module.exports = __webpack_public_path__ + "static/media/dudumfinancial--background.89874ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/dudumfinancial/dudumfinancial--background.jpg
// module id = 184
// module chunks = 0